import React from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';

const noop = () => { };

export const createWrapperFieldRenderer = ({
    fieldMap,
    dataObj,
    disabled,
    showError,
    defaultOnChange,
    defaultOnError = noop,
    defaultCustomValidation,
}) => (field, options = {}) => {
    const normalizedOptions = typeof options === 'function'
        ? { onChange: options }
        : (options || {});
    const baseJsonField = fieldMap?.[field];
    const jsonField = normalizedOptions?.jsonField || baseJsonField;
    const shouldWireAddressDependents = jsonField?.uiType === 'addressAutocomplete' && typeof jsonField?.parentField === 'string';
    const dependentFieldConfigs = shouldWireAddressDependents
        ? Object.values(fieldMap || {}).filter((entry) => entry?.parentField === jsonField?.parentField)
        : undefined;

    if (!jsonField?.uiType) {
        return null;
    }

    return (
        <WrapperField
            key={normalizedOptions?.key || field}
            disabled={normalizedOptions?.disabled ?? disabled}
            jsonField={jsonField}
            dataObj={dataObj}
            arrayIndexing={normalizedOptions?.arrayIndexing}
            onChange={normalizedOptions?.onChange || defaultOnChange}
            showError={showError}
            onError={normalizedOptions?.onError || defaultOnError}
            className={normalizedOptions?.className}
            customOperator={normalizedOptions?.customOperator}
            customProp={normalizedOptions?.customProp ?? dependentFieldConfigs}
            haveDependentSubFields={normalizedOptions?.haveDependentSubFields ?? shouldWireAddressDependents}
            requiredOverride={normalizedOptions?.requiredOverride}
            loading={normalizedOptions?.loading}
            setLoading={normalizedOptions?.setLoading}
            asDisplay={normalizedOptions?.asDisplay}
            isForEDD={normalizedOptions?.isForEDD}
            customValidation={normalizedOptions?.customValidation || defaultCustomValidation}
        />
    );
};
